import React from 'react';

import { useDangerNotification } from '../hooks/useDangerNotification';

import { DangerNotificationDialog } from './DangerNotificationDialog';

export const DangerNotificationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const {
    dangerNotification,
    isDialogOpen,
    handleCloseDialog,
    handleMarkAsRead,
  } = useDangerNotification();

  return (
    <>
      {children}

      {dangerNotification && (
        <DangerNotificationDialog
          notification={dangerNotification}
          open={isDialogOpen}
          onClose={handleCloseDialog}
          onMarkAsRead={handleMarkAsRead}
        />
      )}
    </>
  );
};
